import {
  addRemarksFailure,
  addRemarksSuccess,
  fetchAllInvoicesFailure,
  fetchAllInvoicesSuccess,
  fetchCustomerInvoicesFailure,
  fetchCustomerInvoicesSuccess,
  fetchInvoiceFailure,
  fetchInvoiceSuccess,
  fetchInvoiceViewsFailure,
  fetchInvoiceViewsSuccess,
  fetchRemarksFailure,
  fetchRemarksSuccess,
  fetchVendorInvoicesFailure,
  fetchVendorInvoicesSuccess,
} from './InvoiceAction';
import {
  customerInvoiceViewAllEffect,
  invoiceViewAllEffect,
  invoiceViewEffect,
  invoiceViewsEffect,
  vendorInvoiceViewAllEffect,
} from './InvoiceEffect';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  FETCH_ALL_INVOICE_REQUEST,
  FETCH_CUSTOMER_ALL_INVOICE_REQUEST,
  FETCH_INVOICE_REQUEST,
  FETCH_INVOICE_VIEWS_REQUEST,
  FETCH_VENDOR_ALL_INVOICE_REQUEST,
  REMARKS_TYPES,
} from './InvoiceType';
function* fetchInvoiceSaga(action) {
 
  try {
    const invoiceId = action.payload?.invoiceId;

    const response = yield call(invoiceViewEffect, invoiceId);
   
    const familyMembers = response.data.data || [];

    yield put(fetchInvoiceSuccess(familyMembers));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      'Failed to fetch family members';
    yield put(fetchInvoiceFailure(errorMessage));
  }
}

function* fetchInvoicesSaga(payload) {
  try {
    const response = yield call(invoiceViewAllEffect,payload?.payload);

    yield put(fetchAllInvoicesSuccess(response));
  } catch (error) {
    const errorMessage = error.response
      ? error.response.data.message
      : error.message;
    yield put(fetchAllInvoicesFailure(errorMessage));
  }
}
function* fetchCustomerInvoicesSaga(payload) {
  try {
    const response = yield call(customerInvoiceViewAllEffect, payload?.payload);

    yield put(fetchCustomerInvoicesSuccess(response));
  } catch (error) {
    const errorMessage = error.response
      ? error.response.data.message
      : error.message;
    yield put(fetchCustomerInvoicesFailure(errorMessage));
  }
}
function* fetchVendorInvoicesSaga(payload) {
  try {
    const response = yield call(vendorInvoiceViewAllEffect, payload?.payload);
    yield put(fetchVendorInvoicesSuccess(response));
  } catch (error) {
    const errorMessage = error.response
      ? error.response.data.message
      : error.message;
    yield put(fetchVendorInvoicesFailure(errorMessage));
  }
}

function* fetchInvoiceViewsSaga() {
  try {
    const response = yield call(invoiceViewsEffect);

    yield put(fetchInvoiceViewsSuccess(response));
  } catch (error) {
    const errorMessage = error.response
      ? error.response.data.message
      : error.message;
    yield put(fetchInvoiceViewsFailure(errorMessage));
  }
}

export default function* invoiceSaga() {
  yield takeLatest(FETCH_INVOICE_REQUEST, fetchInvoiceSaga);
  yield takeLatest(FETCH_ALL_INVOICE_REQUEST, fetchInvoicesSaga);
   yield takeLatest(FETCH_INVOICE_VIEWS_REQUEST, fetchInvoiceViewsSaga);
  yield takeLatest(
    FETCH_CUSTOMER_ALL_INVOICE_REQUEST,
    fetchCustomerInvoicesSaga
  );
  yield takeLatest(FETCH_VENDOR_ALL_INVOICE_REQUEST, fetchVendorInvoicesSaga);
  
}
